import { render, staticRenderFns } from "./SlidersIcon.vue?vue&type=template&id=3d7e9510&"
import script from "./SlidersIcon.vue?vue&type=script&lang=js&"
export * from "./SlidersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports